import { RewardWallet } from '@maverick/entity';
import { DateWithoutUTCFormat, UtilsGetDateDiffInDays } from '@maverick/utils';

export const toastError =
    'Sorry, there was an error with your login request. Please check your account information and try again. If the problem continues, contact customer support.';

export enum UserInfo {
    Email = 'email',
    FamilyName = 'family_name',
    GivenName = 'given_name',
    MobileNumber = 'mobileNum',
    LoyaltyId = 'loyaltyId',
    newUser = 'newUser',
}

export const isBasketExpired = (basketCreationDate: Date | null) => {
    const staleBasket =
        !basketCreationDate || UtilsGetDateDiffInDays(basketCreationDate, DateWithoutUTCFormat(new Date())) >= 7;
    return staleBasket;
};

export const fetchUserInfoFromToken = (decodedToken: any) => {
    const userInfoPrefix = 'https://dine-Rewards/';

    const userInfo = {
        givenName: decodedToken[userInfoPrefix + UserInfo.GivenName],
        familyName: decodedToken[userInfoPrefix + UserInfo.FamilyName],
        email: decodedToken[userInfoPrefix + UserInfo.Email],
        mobileNumber: decodedToken[userInfoPrefix + UserInfo.MobileNumber],
        newUser: decodedToken[userInfoPrefix + UserInfo.newUser],
    };

    return userInfo;
};

export const filterRewards = (rewards: RewardWallet[], days: number) => {
    const currentDate = new Date();
    const expirationDate = new Date();

    expirationDate.setDate(currentDate.getDate() + days);

    const result = rewards.filter((reward) => {
        const rewardExpirationDate = new Date(reward.expirationDate);
        return rewardExpirationDate <= expirationDate;
    });

    return result;
};
